document.addEventListener("DOMContentLoaded", function () {
  // Select all sets of tabs with the class "main_tab_row"
  const tabSets = document.querySelectorAll(".main_tab_row");

  // Loop through each tab set
  tabSets.forEach(function (tabSet) {
    if (window.matchMedia("(min-width: 0px)").matches) {
      const customTab = tabSet.querySelector(".custom_tab");
      const tabTitles = customTab.querySelector(".tab_titles");

      const activeBar = document.createElement("div");
      activeBar.className = "active_bar";

      tabTitles.appendChild(activeBar);
    }

    const mainWrap = tabSet.closest('.tab_sec');
    const tabTitles = tabSet.querySelectorAll(".tab_title");
    const tabContents = tabSet.querySelectorAll(".tab_content");
    const activeBar = tabSet.querySelector(".active_bar");

    function setActiveTab(index) {
      // Remove 'active' class from all tab titles
      tabTitles.forEach(function (tabTitle) {
        tabTitle.classList.remove("active");
      });

      // Add 'active' class to the clicked tab title
      tabTitles[index].classList.add("active");

      // Hide all tab contents
      tabContents.forEach(function (content) {
        content.classList.remove("show");
      });

      // Show the tab content corresponding to the clicked item
      tabContents[index].classList.add("show");

      // Calculate the width and left position of the active bar
      const activeTabTitle = tabTitles[index];
      const tabWidth = activeTabTitle.offsetWidth;
      const tabLeft =
        activeTabTitle.getBoundingClientRect().left -
        tabTitles[0].parentElement.getBoundingClientRect().left;

      if (window.matchMedia("(min-width: 0)").matches) {
        // Set the width and left position of the active bar
        activeBar.style.width = tabWidth + "px";
        activeBar.style.left = tabLeft + "px";
      }
    }

    tabTitles.forEach(function (title, index) {
      title.addEventListener("click", function (e) {
        e.preventDefault();
        setActiveTab(index);
        document.querySelectorAll('.btn_two').forEach(b=>b.href=tabTitles[index].dataset.href);
        // $(".product_slider").slick("refresh")
      });
    });

    setActiveTab(0);
    document.querySelectorAll('.btn_two').forEach(b=>b.href=tabTitles[0].dataset.href);
  });

  jQuery(window).on("scroll", onScroll);

  function onScroll(event) {
    var scrollPos = jQuery(document).scrollTop();
    jQuery(".custom_tab .tab_title a").each(function () {
      var currLink = jQuery(this);
      var refElement = jQuery(currLink.attr("href"));
      if (
        refElement.offset().top - 200 <= scrollPos &&
        refElement.offset().top + refElement.height() > scrollPos
      ) {
        jQuery(".custom_tab .tab_title, .custom_tab .tab_title a").removeClass(
          "active"
        );
        currLink.addClass("active");
        currLink.parent().addClass("active");

        // Calculate the width and left position of the active bar
        var tabWidth = currLink.width();
        var tabLeft =
          currLink.offset().left - jQuery(".tab_titles").offset().left;
        var activeBar = jQuery(".active_bar");

        // Set the width and left position of the active bar
        activeBar.css({ width: tabWidth, left: tabLeft });
      } else {
        currLink.removeClass("active");
        currLink.parent().removeClass("active");
      }
    });
  }

  jQuery(".custom_tab .tab_title a").each(function () {
    jQuery(this).on("click", function (event) {
      event.preventDefault();
      var currentId = jQuery(this).attr("href");
      setTimeout(() => {
        jQuery("html, body").animate(
          {
            scrollTop: jQuery(currentId).offset().top - 120,
          },
          0
        );
      }, 0);
    });
  });
});

$(document).ready(function () {
  // Check if there is a hash in the URL
  if (window.location.hash) {
    // Get the hash
    var hash = window.location.hash;

    // Scroll to the element with the matching ID
    $("html, body").animate(
      {
        scrollTop: $(hash).offset().top,
      },
      500
    ); // 1000 milliseconds (1 second) for the animation
  }
});
